import React from 'react';
import { Container } from './styled';

function Layout({ children }) {
  return <Container>{children}</Container>;
}

export default Layout;
